import React from "react";
import { Sparkle, Hammer, HeartHandshake } from "lucide-react";
import { FadeUp } from "./Reveal";

const pillars = [
    { icon: Sparkle, title: "A Promise of Purity", text: "Guaranteed purity on every piece — what you see is what you get." },
    { icon: Hammer, title: "Exceptional Craftsmanship", text: "From traditional designs to modern looks — every piece is handcrafted." },
    { icon: HeartHandshake, title: "Trust Like Family", text: "This isn't just a shop — it's a family jewellery home in Supaul." },
];

export default function About() {
    return (
        <section id="about" data-testid="about-section" className="py-24 sm:py-32">
            <div className="max-w-7xl mx-auto px-5 sm:px-8">
                <div className="grid md:grid-cols-12 gap-10 md:gap-16 items-start">
                    <div className="md:col-span-5">
                        <FadeUp>
                            <p className="eyebrow">Our Story</p>
                            <h2 className="font-display font-light text-3xl sm:text-4xl lg:text-5xl leading-tight mt-4">
                                A family jewellery house — where{" "}
                                <span className="italic text-gold-gradient">trust</span> is the most precious metal.
                            </h2>
                        </FadeUp>
                    </div>
                    <div className="md:col-span-7 md:pt-14">
                        <FadeUp delay={0.15}>
                            <p className="text-clay leading-relaxed text-base">
                                Maa Gayatri Jewellers is a family-run jewellery house in Supaul. Gold, silver,
                                diamond and high-end imitation — every customer is family, and every ornament
                                becomes a relationship. A wedding, a festival, or the start of something new —
                                being part of your special moments is our pride.
                            </p>
                        </FadeUp>
                        <div className="mt-12 space-y-0">
                            {pillars.map((p, i) => (
                                <FadeUp key={p.title} delay={0.1 + i * 0.12}>
                                    <div data-testid={`about-pillar-${i}`} className="group flex gap-6 py-7 border-t border-gold/15 last:border-b hover:bg-obsidian-soft transition-colors duration-300 px-2 sm:px-4">
                                        <p.icon size={22} className="text-gold shrink-0 mt-1 group-hover:text-gold-light transition-colors" />
                                        <div>
                                            <h3 className="font-display text-xl text-gold-light">{p.title}</h3>
                                            <p className="text-muted text-sm mt-1.5 leading-relaxed">{p.text}</p>
                                        </div>
                                    </div>
                                </FadeUp>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
